// extracted by mini-css-extract-plugin
export default {"mainText":"LinkExpired_mainText__H7KuT","navText":"LinkExpired_navText__wPzWF"};